import {
    VIRTUAL_BUNDLE_SALES_DETAILS_SUCCESS,
    VIRTUAL_BUNDLE_SALES_DETAILS_LOADING,
  } from '../actions/VirtualBundleSalesUploadDetailsAction';
  
  const initialState = {
    virtualBundleSalesDetailData: [],
    isLoading: true
  };
  
  const VirtualBundleSalesUploadDetailsReducer = (state = initialState, action = {}) => {
    switch (action.type) {
      case VIRTUAL_BUNDLE_SALES_DETAILS_SUCCESS:
        return { ...state, virtualBundleSalesDetailData: action.data, isLoading: false };
      case VIRTUAL_BUNDLE_SALES_DETAILS_LOADING:
        return { ...state, isLoading: action.isLoading };
      default:
        return state;
    }
  };
  
  export default VirtualBundleSalesUploadDetailsReducer;
  